<template>
  <div class="picture_list">
    <el-row :gutter="10">
      <el-col :span="4" v-for="i in listData" :key="i.id">
        <showPicture :itemList="i" style="margin-left:0.2rem;margin-bottom:0.2rem" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { fscDate } from '../../../static/mixins/fastChooseDate'
import showPicture from './PictureItem'
export default {
  name: 'PictureList',
  mixins: [fscDate],
  components: { showPicture },
  props: ['listData'],
  data() {
    return {}
  },
  mounted() {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/PictureCom/PictureList.vue